import React, { useState } from 'react';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import { FaHeadset, FaEnvelope, FaPhone, FaClock, FaFileAlt, FaCheckCircle, FaCheck, FaExclamationTriangle, FaSpinner, FaTimes, FaPaperPlane } from 'react-icons/fa';
import '../Assets/Styles/Pages/complaints_page.css';

const Complaints_page = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    complaintType: '',
    subject: '',
    complaintDetails: ''
  });
  const [file, setFile] = useState(null);
  const [submitStatus, setSubmitStatus] = useState({ loading: false, error: null, success: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus({ loading: true, error: null, success: false });
    
    const submitData = new FormData();
    
    // Append all form fields
    Object.keys(formData).forEach(key => {
      submitData.append(key, formData[key]);
    });
    
    // Append file if exists
    if (file) {
      submitData.append('attachedDocuments', file);
    }
    
    try {
      const response = await fetch('https://tstock.trillionstechsolutions.com/complaints/create', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        mode: 'cors', // Enable CORS
        body: submitData
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || 'Failed to submit complaint');
      }
      
      const result = await response.json();
      console.log('Submission successful:', result);
      setSubmitStatus({ loading: false, error: null, success: true });
      
      // Reset form after successful submission
      setFormData({
        fullName: '',
        emailAddress: '',
        phoneNumber: '',
        complaintType: '',
        subject: '',
        complaintDetails: ''
      });
      setFile(null);
      
      // Reset file input
      const fileInput = document.getElementById('attachments');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      console.error('Error submitting complaint:', error);
      setSubmitStatus({ 
        loading: false, 
        error: error.message || 'Failed to submit complaint. Please try again.', 
        success: false 
      });
    }
  };

  const complaintTypes = [
    "Service Related",
    "Technical Issues",
    "Billing Related",
    "Account Related",
    "Investment Related",
    "Other"
  ];

  const complaintStats = [
    {
      icon: <FaCheck />,
      title: "Total Complaints Received",
      value: "0",
      description: "Complaints received in August 2026"
    },
    {
      icon: <FaClock />,
      title: "Total Complaints Resolved",
      value: "0",
      description: "Complaints resolved in August 2026"
    },
    {
      icon: <FaExclamationTriangle />,
      title: "Pending Complaints",
      value: "0",
      description: "Total pending complaints at month end"
    },
    {
      icon: <FaCheckCircle />,
      title: "Average Resolution Time",
      value: "N.A",
      description: "Average resolution time in days"
    }
  ];

  const monthlyTrendData = [
    { month: "March, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "April, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "May, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "June, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "July, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "August, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "September, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "October, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "November, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "December, 2025", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "January, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "February, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "March, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "April, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "May, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "June, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "July, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
    { month: "August, 2026", carriedForward: 0, received: 0, resolved: 0, pending: 0 },
  ];

  return (
    <div className="complaints-page">
      <AboutNav />
      <SEBISlider />
      
      <section className="complaints-hero">
        <div className="complaints-hero-content">
          <h1>File a Complaint</h1>
          <p>We take your concerns seriously and are committed to resolving them promptly</p>
        </div>
      </section>

      <section className="complaints-container">
        <div className="complaints-intro">
          <h2>Our Complaint Resolution Process</h2>
          <p>At Trillion Stock Research, we have a structured process to handle and resolve your complaints efficiently. Our dedicated team ensures that each complaint receives the attention it deserves.</p>
        </div>

        <div className="complaints-stats">
          {complaintStats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                {stat.icon}
              </div>
              <div className="stat-content">
                <h3>{stat.title}</h3>
                <div className="stat-value">{stat.value}</div>
                <p>{stat.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="complaints-grid">
          <div className="complaints-form-container">
            <form onSubmit={handleSubmit} className="complaints-form">
              <div className="form-group">
                <label htmlFor="fullName">Full Name *</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="emailAddress">Email Address *</label>
                <input
                  type="email"
                  id="emailAddress"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phoneNumber">Phone Number *</label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="complaintType">Complaint Type *</label>
                <select
                  id="complaintType"
                  name="complaintType"
                  value={formData.complaintType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Complaint Type</option>
                  {complaintTypes.map((type, index) => (
                    <option key={index} value={type}>{type}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="complaintDetails">Complaint Details *</label>
                <textarea
                  id="complaintDetails"
                  name="complaintDetails"
                  value={formData.complaintDetails}
                  onChange={handleChange}
                  required
                  rows="5"
                ></textarea>
              </div>

              <div className="form-group">
                <label htmlFor="attachments">Attach Documents (Optional)</label>
                <input
                  type="file"
                  id="attachments"
                  name="attachments"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
              </div>

              {submitStatus.error && (
                <div className="status-message error-message">
                  <FaTimes className="status-icon" />
                  {submitStatus.error}
                </div>
              )}

              {submitStatus.success && (
                <div className="status-message success-message">
                  <FaCheckCircle className="status-icon" />
                  Complaint submitted successfully! We'll get back to you soon.
                </div>
              )}

              <button 
                type="submit" 
                className="submit-button"
                disabled={submitStatus.loading}
              >
                <div className="button-content">
                  {submitStatus.loading ? (
                    <>
                      <FaSpinner className="submit-spinner" />
                      Submitting...
                    </>
                  ) : (
                    <>
                      <FaPaperPlane />
                      Submit Complaint
                    </>
                  )}
                </div>
              </button>
            </form>
          </div>

          {submitStatus.loading && (
            <div className="loading-overlay">
              <div className="loading-spinner"></div>
            </div>
          )}

          <div className="complaints-info">
            <div className="info-card">
              <FaHeadset className="info-icon" />
              <h3>24/7 Support</h3>
              <p>Our support team is available round the clock to assist you</p>
            </div>

            <div className="info-card">
              <FaEnvelope className="info-icon" />
              <h3>Email Support</h3>
              <p>mail.trillionstockresearch@gmail.com</p>
            </div>

            <div className="info-card">
              <FaPhone className="info-icon" />
              <h3>Phone Support</h3>
              <p>+91 9977555378</p>
            </div>

            <div className="info-card">
              <FaClock className="info-icon" />
              <h3>Response Time</h3>
              <p>We aim to respond within 24 hours</p>
            </div>

            <div className="info-card">
              <FaFileAlt className="info-icon" />
              <h3>Documentation</h3>
              <p>Keep all relevant documents ready for faster resolution</p>
            </div>

            <div className="info-card">
              <FaCheckCircle className="info-icon" />
              <h3>Resolution Process</h3>
              <p>We follow a systematic approach to resolve complaints</p>
            </div>
          </div>
        </div>

        <div className="complaints-data-tables">
          <h2>Complaint Data - Month Ending August, 2026</h2>
          
          {/* Desktop Tables - Hidden on mobile */}
          <div className="desktop-tables">
            <div className="table-container">
            <h3>Monthly Complaint Summary</h3>
            <table className="complaints-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Received from</th>
                  <th>Pending at the end of last month</th>
                  <th>Received</th>
                  <th>Resolved</th>
                  <th>Total Pending</th>
                  <th>Pending complaints &gt; 3months</th>
                  <th>Average Resolution time (in days)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Directly from Investors</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>N. A</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>SEBI (SCORES)</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>N. A</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Other Sources (If any)</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>N. A</td>
                </tr>
                <tr className="grand-total">
                  <td colSpan="2">Grand Total</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>N. A</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-container">
            <h3>Trend of Monthly Disposal of Complaints</h3>
            <table className="complaints-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Month</th>
                  <th>Carried forward from previous month</th>
                  <th>Received</th>
                  <th>Resolved</th>
                  <th>Pending</th>
                </tr>
              </thead>
              <tbody>
                {monthlyTrendData.map((row, index) => (
                  <tr key={row.month}>
                    <td>{index + 1}.</td>
                    <td>{row.month}</td>
                    <td>{row.carriedForward}</td>
                    <td>{row.received}</td>
                    <td>{row.resolved}</td>
                    <td>{row.pending}</td>
                  </tr>
                ))}
                <tr className="grand-total">
                  <td colSpan="2">Grand Total</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-container">
            <h3>Trend of Annual Disposal of Complaints</h3>
            <table className="complaints-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Year</th>
                  <th>Carried forward from previous month</th>
                  <th>Received</th>
                  <th>Resolved</th>
                  <th>Pending</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2024-25</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>2025-2026</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr className="grand-total">
                  <td colSpan="2">Grand Total</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>

          {/* Mobile-friendly tables for small devices */}
          <div className="mobile-tables">
            <h3>Mobile View - Complaint Data</h3>
            
            <div className="mobile-table-container">
              <h4>Monthly Summary (Mobile)</h4>
              <div className="mobile-cards">
                <div className="mobile-card">
                  <div className="card-header">Directly from Investors</div>
                  <div className="card-row">
                    <span className="label">Pending (last month):</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Received:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Resolved:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Total Pending:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Pending &gt; 3months:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Avg Resolution:</span>
                    <span className="value">N.A</span>
                  </div>
                </div>

                <div className="mobile-card">
                  <div className="card-header">SEBI (SCORES)</div>
                  <div className="card-row">
                    <span className="label">Pending (last month):</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Received:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Resolved:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Total Pending:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Pending &gt; 3months:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Avg Resolution:</span>
                    <span className="value">N.A</span>
                  </div>
                </div>

                <div className="mobile-card">
                  <div className="card-header">Other Sources</div>
                  <div className="card-row">
                    <span className="label">Pending (last month):</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Received:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Resolved:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Total Pending:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Pending &gt; 3months:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Avg Resolution:</span>
                    <span className="value">N.A</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mobile-table-container">
              <h4>Monthly Trend (Mobile)</h4>
              <div className="mobile-cards">
                {monthlyTrendData.map((row) => (
                  <div className="mobile-card" key={row.month}>
                    <div className="card-header">{row.month}</div>
                    <div className="card-row">
                      <span className="label">Carried forward:</span>
                      <span className="value">{row.carriedForward}</span>
                    </div>
                    <div className="card-row">
                      <span className="label">Received:</span>
                      <span className="value">{row.received}</span>
                    </div>
                    <div className="card-row">
                      <span className="label">Resolved:</span>
                      <span className="value">{row.resolved}</span>
                    </div>
                    <div className="card-row">
                      <span className="label">Pending:</span>
                      <span className="value">{row.pending}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mobile-table-container">
              <h4>Annual Trend (Mobile)</h4>
              <div className="mobile-cards">
                <div className="mobile-card">
                  <div className="card-header">2024-25</div>
                  <div className="card-row">
                    <span className="label">Carried forward:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Received:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Resolved:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Pending:</span>
                    <span className="value">0</span>
                  </div>
                </div>

                <div className="mobile-card">
                  <div className="card-header">2025-2026</div>
                  <div className="card-row">
                    <span className="label">Carried forward:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Received:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Resolved:</span>
                    <span className="value">0</span>
                  </div>
                  <div className="card-row">
                    <span className="label">Pending:</span>
                    <span className="value">0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="complaints-process">
          <h2>Our Complaint Resolution Process</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Submit Complaint</h3>
              <p>Fill out the complaint form with all necessary details</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Review</h3>
              <p>Our team reviews your complaint and assigns it to the appropriate department</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Investigation</h3>
              <p>We investigate the matter thoroughly and gather all relevant information</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Resolution</h3>
              <p>We provide a detailed response and implement necessary solutions</p>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <h3>Follow-up</h3>
              <p>We ensure your satisfaction with the resolution provided</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ISOCertificateButton />
    </div>
  );
};

export default Complaints_page;
